module.exports = __webpack_public_path__ + "img/download-on-appstore.9d51a430.svg";